function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56 0H4a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4h52a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zM20.31 47.5h-7.26V24.14h7.26zm-.62-27.81a4.22 4.22 0 0 1-7.19-3 4.27 4.27 0 0 1 4.22-4.22 4.2 4.2 0 0 1 3 7.19zM47.5 47.5h-7.27V36.09a12.74 12.74 0 0 0-.46-4.09 3.3 3.3 0 0 0-3.36-2.11 3.67 3.67 0 0 0-3.52 1.88 8.69 8.69 0 0 0-.78 4.14V47.5h-7.19V24.14h7v3.2H32a6.22 6.22 0 0 1 2.5-2.57 7.66 7.66 0 0 1 4.38-1.25c3.38 0 5.75 1.06 7.11 3.2 1 1.72 1.56 4.37 1.56 8z",
  fill: "#fff"
});

var SvgLinkedinWht = function SvgLinkedinWht(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedinWht, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin_wht.1af40d1a.svg";
export { ForwardRef as ReactComponent };